import {
	CUSTOMER_SERVICE_PROJECT,
	type ProjectType,
} from '@jira/platform__project-types/src/project-types.tsx';

import { PREMIUM_EDITION } from '@jira/platform__application-editions/src/edition.tsx';
// eslint-disable-next-line jira/restricted/@jira+platform__services-providers-project-context
import { useProjectContext } from '@jira/platform__services-providers-project-context/src/index.tsx';
import { isCsmPath } from '@jira/customer-service__live-conversations-common/src/isCsmPath.tsx';
import { useAppEditions } from '@atlassian/jira-tenant-context-controller/src/components/app-editions/index.tsx';
import { useApplicationPermissions } from '@atlassian/jira-tenant-context-controller/src/components/application-permissions/index.tsx';
import { createRouterSelector } from '@atlassian/react-resource-router';
import { fg } from '@atlassian/jira-feature-gating';

const useIsCSMRoute = createRouterSelector((state) => isCsmPath(state.match.path));

// This hook is used in the top navigation to determine whether or not the live conversations activity status indicator is rendered
// ⚠️ It must remain SSR compatible ⚠️
// ⚠️ Do not add any browser APIs or async data sources here ⚠️
export const useIsEligibleForLiveConversationsActivityStatusSsr = (
	projectType?: ProjectType,
): boolean => {
	const { hasCustomerServiceAccess } = useApplicationPermissions();
	const { customerService: customerServiceEdition } = useAppEditions();
	const isCSMProjectRoute = projectType === CUSTOMER_SERVICE_PROJECT; // note: remove when cleaning csm_appification_standalone_navigation
	const isCSMRoute = useIsCSMRoute();

	// If updating, make sure the resource is fetching under the same or broader conditions
	// shouldFetchCSMLiveChatAgent in src/packages/navigation-apps/resources/src/services/top-nav/index.tsx
	return (
		hasCustomerServiceAccess &&
		customerServiceEdition === PREMIUM_EDITION &&
		(isCSMProjectRoute || isCSMRoute) &&
		fg('csm-omni-channel-live-chat-in-widget')
	);
};

export const useIsEligibleForLiveConversationsActivityStatus = (): boolean => {
	const { data: projectContextData } = useProjectContext();
	return useIsEligibleForLiveConversationsActivityStatusSsr(projectContextData?.projectType);
};
